import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Theme, styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import * as React from 'react';

const HeroLayoutRoot = styled('section')(({ theme }) => ({
  color: theme.palette.common.white,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    height: '80vh',
    minHeight: 500,
    maxHeight: 1300,
  },
}));

const Background = styled('div')({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  zIndex: -2,
});

interface HeroLayoutProps {
  sxBackground: SxProps<Theme>;
}

export const HeroLayout = (
  props: React.HTMLAttributes<HTMLDivElement> & HeroLayoutProps,
) => {
  const { sxBackground, children } = props;

  return (
    <HeroLayoutRoot>
      <Container
        sx={{
          mt: 3,
          mb: 14,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {children}
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: 'common.black',
            opacity: 0.5,
            zIndex: -1,
          }}
        />
        <Background sx={sxBackground} />
        <ArrowDownwardIcon
          sx={{ height: '16', width: '12', position: 'absolute', bottom: 32 }}
        />
      </Container>
    </HeroLayoutRoot>
  );
};
